import React, { useEffect, useState } from "react";
import Button from "../Button/Button";
import { useFormik } from "formik";
import { createValidationSchemas } from "../../schemas/user.schema";
import { authService } from "../../services/auth.service";
import { toast } from "react-hot-toast";
import Input from "../input/Input";
import { useTranslation } from "react-i18next";

const ForgetPasswordModal = ({ setstate1, setEmail }) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const validationSchemas = createValidationSchemas(t);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchemas.validateForgetpasswordForm,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const data = { email: values.email.toLowerCase() };
        setEmail(data.email);
        const user = await authService.forgotPassword(data);
        if (user?.status === 200 || user?.status === 201) {
          toast.success("Email Sent Successfully!");
          setLoading(false);
          setstate1(6);
        }
      } catch (error) {
        console.log(error.data);
        setLoading(false);
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        } else {
          console.log(error.response);
        }
      }
    },
  });

  useEffect(() => {
    const firstInput = document.getElementById("email");
    firstInput.focus();
    firstInput.select();
  }, []);
  return (
    <div className="w-full">
      <div className="flex flex-col md:gap-8 gap-4">
        <div>
          <h3 className="modal-heading mb-1">{t("Forgot your password?")}</h3>
          <p className="modal-description !text-base">
            {t("Enter your registered email to receive")}{" "}
            <span>{t("password reset instructions.")}</span>
          </p>
        </div>
        <form className="flex flex-col gap-6" onSubmit={formik.handleSubmit}>
          <Input
            id="email"
            name="email"
            placeholder={t("Enter your email")}
            className="focus:border-secondary-1000"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.email}
          />
          <div className="flex flex-col gap-10">
            <Button
              type="submit"
              isLoading={loading}
              disabled={!formik.isValid || !formik.dirty || loading}
              value={t("Submit")}
            />

            <p className="text-center text-secondary-1000 text-sm">
              {t("Remember Password? ")}
              <span
                className="text-primary cursor-pointer"
                onClick={() => {
                  setstate1(1);
                }}
              >
                {t("Log in")}
              </span>{" "}
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgetPasswordModal;
